import { API } from "../constants/api"
import HttpProvider from "./httpProvider"

class BailkalService {
  constructor() {
    this.http = HttpProvider
  }

  async loadTypesContragent() {
    return await this.http.get(API.BAILKAL.TYPE_CONTRAGENTS(), false)
  }

  async getRequest(id) {
    return await this.http.get(API.BAILKAL.REQUEST({ id }), false)
  }

  async getCities(orderDeliveryRequestGroupId, search = "") {
    return await this.http.post(API.BAILKAL.SEARCH_CITIES({ orderDeliveryRequestGroupId }), { search })
  }

  async getStreets(orderDeliveryRequestGroupId, city, search = "", isFrom = false) {
    return await this.http.post(API.BAILKAL.SEARCH_STREETS({ orderDeliveryRequestGroupId, city, isFrom }), { search })
  }

  async getTimeSchedule(city, isFrom = false) {
    return await this.http.get(API.BAILKAL.TIME_SCHEDULE({ city, isFrom }), false)
  }

  async getContragentTemplates() {
    return await this.http.get(API.BAILKAL.CONTRAGENTS_ALL(), false)
  }

  async updateRequest(data) {
    return await this.http.put(API.BAILKAL.REQUEST_UPDATE(), data)
  }

  async createOrder(data) {
    return await this.http.put(API.BAILKAL.REQUEST_CREATE(), data)
  }

  async getExistRequest(id) {
    return await this.http.get(API.BAILKAL.EXIST_REQUEST({ id }), false)
  }

  async getTracking(id) {
    return await this.http.get(API.BAILKAL.GET_TRACKING({ id }), false)
  }
}

export default new BailkalService()
